<template>
    <div>
        <breadCrumb 
            :icon="'fa-broadcast-tower'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_broadcast`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button"  @click="addToggle = !addToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t('subMenu.my_salon_broadcast')}}</span>
            </button>
        </div>
        <div v-if="addToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add')}}{{$t('subMenu.my_salon_broadcast')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <broadcastForm :isEdit="false" @returnParent="filterBroadCastItem"></broadcastForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> --> 
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start">
                            <div class="dataTables_filter mb-2">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchBroadcast" @keypress.enter="filterSearchBroadcast">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchBroadcast()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2"> 
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                            <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.broadcastTabs" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterByGroup(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table small striped hover bordered :fields="fields" :items="broadcastItems" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(postedDate)="data">
                                            {{formatDate(data.item.postedDate, true)}}
                                        </template>
                                        <template #cell(image)="data">
                                            <div class="position-relative broadcast-container">
                                                <img class="broadcast-image" :src="getImage(data.item.path)"/>
                                                <a class="btn btn-xs btn-outline-primary text-primary" title="View Broadcast Target" @click="showBroadcastTarget(data.item.bcastID, data.item.path)">
                                                    <i class="fas fa-user-friends"></i>
                                                </a>
                                            </div>
                                        </template>
                                        <template #cell(outlet)="data">{{data.item.outletID == 0 ? $t('label.all', {'item': $t('label.outlet')}) : getOutlet(data.item.outletID)}}</template>
                                        <template #cell(title)="data">
                                            <a class="link fw-700 text-primary" @click="showEdit(data.item)">{{data.item.title == "" ? '-' : data.item.title}}</a>
                                            <h6 class="mt-3 fw-500" style="text-decoration: underline">{{$t('table.header.caption')}}:</h6>
                                            <span class="fw-300 d-block">{{data.item.caption == "" ? '-' : data.item.caption}}</span>
                                            <div class="text-center mt-3">
                                                <a class="d-block badge link badge border border-primary text-primary" @click="showRepost(data.item)">
                                                    {{$t('button_link.repost')}}
                                                </a>
                                            </div>
                                        </template>
                                        <template #cell(totalLikes)="data">
                                            <a class="link" title="View Broadcast Like" @click="showLikeComment(data.item.bcastID, 'likes')">
                                                <i class="h3 fal fa-thumbs-up like-comment-icon"></i>
                                                <span class="position-relative badge badge-icon">{{data.item.totalLikes}}</span>
                                            </a>
                                        </template>
                                        <template #cell(totalComments)="data">
                                            <a class="link" title="View Broadcast Comment" @click="showLikeComment(data.item.bcastID, 'comments')">
                                                <i class="h3 fal fa-comment-alt like-comment-icon"></i>
                                                <span class="position-relative badge badge-icon">{{data.item.totalComments}}</span>
                                            </a>
                                        </template>
                                        <template #cell(rewardQR)="data">
                                            <div v-if="data.item.rewardID == 0">
                                                <span v-if="data.item.outletID == 0" class="badge badge-secondary">{{$t('table.value.disable')}}</span>
                                                <a v-else class="link d-block text-primary text-center" title="Add Reward QR" @click="handleRewardQR(data.item.outletID, data.item.bcastID, data.item.rewardID, data.item.rewardTitle, 'add')">
                                                    <div class='icon-stack fs-xl mb-1'>
                                                        <i class="fal fa-gift icon-stack-3x opacity-100 color-primary-500"></i>
                                                        <i class="fal fa-plus icon-stack-2x opacity-100 color-primary-300 ml-3" style="top: .5em;"></i>
                                                    </div>
                                                </a>
                                            </div>
                                            <div class="p-3" v-else>
                                                <span class="text-dark">{{data.item.rewardTitle == "" ? "-" : data.item.rewardTitle}}</span>
                                                <a class="d-block link badge border border-primary text-primary" title="Delete Reward QR" @click="handleRewardQR(data.item.outletID, data.item.bcastID, data.item.rewardID, data.item.rewardTitle, 'delete')">
                                                    {{$t('button_link.remove')}}
                                                </a>
                                                <h6 class="mt-3 fw-500" style="text-decoration: underline">{{$t('table.header.reward_period')}}:</h6>
                                                <span v-if="data.item.rewardStartDate == 0 && data.item.rewardEndDate == 0">-</span>
                                                <div class="fw-300" v-else>
                                                    {{formatDate(data.item.rewardStartDate, false)}} - {{formatDate(data.item.rewardEndDate, false)}}
                                                    <span class="d-block badge" :class="isExpired(data.item.rewardEndDate) ? 'badge-warning' : 'badge-primary'">{{isExpired(data.item.rewardEndDate) ? $t('salon_report.broadcast.expired') : $t('salon_report.broadcast.ongoing')}}</span>   
                                                </div>
                                            </div>
                                        </template>
                                        <template #cell(tukangPost)="data">
                                            <a v-if="data.item.tkPostID == 0" class="link d-block text-primary" :title="$t('button_link.add') + $t('header.post')" @click="handleTukangPost(data.item, 'add')">
                                                <div class='icon-stack h1 mb-1'>
                                                    <img class="img-fluid img-social" :src="require('@/assets/image/icon/tukangLogo.png')"/>
                                                    <i class="fal fa-plus icon-stack-1x opacity-100 color-primary-300 ml-3" style="top: .5em;"></i>
                                                </div>
                                            </a>
                                            <div class="p-3" v-else>
                                                <span class="text-dark">{{data.item.tkPostName == "" ? "-" : data.item.tkPostName}}</span>
                                                <a class="d-block link badge border border-primary text-primary" title="Delete Reward QR" @click="handleTukangPost(data.item, 'delete')">
                                                    {{$t('button_link.remove')}}
                                                </a>
                                            </div>
                                        </template>
                                         <template #cell(action)="data">
                                             <a class="link text-primary" title="Delete Broadcast" @click="deleteBroadcast(data.item)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                         </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggle }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">{{$t('header.edit') + $t('subMenu.my_salon_broadcast')}}
                            <small class="m-0 text-muted">{{$t('subMenu.my_salon_broadcast')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="editToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <broadcastForm ref="broadcastForm" :isEdit="true" @returnParent="filterBroadCastItem"></broadcastForm>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': rewardQRToggle }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal-content-lg">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 fw-500">{{rewardQRTitle}}
                        </h5>
                        <button type="button" class="close" @click="rewardQRToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="rewardQRAction == 'add'">
                            <div class="text-right mb-3">
                                <router-link class="btn buttons-csv buttons-html5 btn-outline-primary" :to="'/dashboard/salon_menu_reward'" >
                                <span class="fal fa-plus mr-2"></span>
                                <span>{{$t('button_link.create') + $t('subMenu.salon_menu_reward')}}</span>
                            </router-link>
                            </div>
                            <div class="panel-tag mt-3" v-if="rewardQR.length == 0">
                                {{$t('message.info.no_reward_qr', {'outlet': selectedOutlet.text})}}
                            </div>
                            <form v-else @submit.prevent="addRewardQR">
                                <div class="form-group">
                                    <label class="form-label">{{$t('table.header.reward_qr')}}</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend w-100">
                                            <label class="input-group-text border-right-0">
                                                <i class="fas fa-tags"></i>
                                            </label>
                                            <multiselect 
                                                :value="selectedRewardQR" 
                                                :options="rewardQR" 
                                                track-by="id" label="text" 
                                                :show-labels="false" 
                                                openDirection="below" 
                                                @select="selectRewardQR">
                                                <span slot="noResult">{{$t('table.no_records')}}</span>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-left mt-5">
                                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                                </div>
                            </form>
                        </div>
                        <div v-else>
                            <p>{{$t('message.confirmation.question', {'action': $t('message.confirmation.action.delete'), 'item': rewardTitle})}}</p>
                            <div class="text-right pt-3 mb-1">
                                <button type="button" class="btn btn-secondary waves-effect waves-themed mr-3" @click="rewardQRToggle = false">{{$t('button_link.cancel')}}</button>
                                <button id="btnDeleteRewardYes" type="button" class="btn btn-primary waves-effect waves-themed" @click="deleteRewardQR">{{$t('button_link.yes')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <broadcastTarget ref="broadcastTarget" :selectedOutlet="selectedOutlet"></broadcastTarget>
        <broadcastLikeComment ref="broadcastLikeComment"></broadcastLikeComment>
        <deleteModal ref="deleteModal" @performConfirmAction="performDeleteAction"></deleteModal>
        <deleteModal ref="repostModal" @performConfirmAction="performRepost"></deleteModal>
        <broadcastTukang ref="broadcastTukang" :tukangPostItems="tukangPostItems" @returnBroadcast="filterBroadCastItem"></broadcastTukang>
    </div>
</template>
<script>
import moment from 'moment'
import BreadCrumb from './../../Bread_Crumb'
import DeleteModal from './../../Delete_Modal'
import BroadcastTarget from './Broadcast_Target'
import BroadcastLikeComment from './Broadcast_Like_Comment'
import BroadcastTukang from './Broadcast_Tukang'
import BroadcastForm from './Broadcast_Form.vue'

import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: "broadcast",
    components:{
        BroadcastTarget, BroadcastLikeComment, DeleteModal, BreadCrumb,
        BroadcastTukang, BroadcastForm
    },
    data(){
        return{
            sTitle: "",
            addToggle: false, editToggle: false,
            selectedTab: "all",
            outlet: [], selectedOutlet: {},
            searchBroadcast: "", groupFilter: "",
            isSpinnerShow: false, broadcastItems: [],
            tukangPostItems: [],
            selectedRewardQR: {}, rewardQR: [], bcastID: 0,
            rewardQRToggle: false, rewardQRAction: "", rewardQRTitle:"", rewardTitle: "", rewardID: 0,
            exportHeaders: [], exportData: [], exportFileName: "", broadcastExportData: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "postedDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "outlet", label: this.$i18n.t('table.header.outlet'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "image", label: this.$i18n.t('subMenu.my_salon_broadcast') + this.$i18n.t('table.header.image'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
                {key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'p-3 align-middle', sortable: true},
                {key: "totalLikes", label: this.$i18n.t('table.header.like'), thClass: 'thead-themed align-middle', tdClass: 'p-1 align-middle', sortable: true},
                {key: "totalComments", label: this.$i18n.t('table.header.comment'), thClass: 'thead-themed align-middle', tdClass: 'p-3 text-center align-middle width-6', sortable: true},
                {key: "rewardQR", label: this.$i18n.t('table.header.reward_qr'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
                // {key: "rewardPeriod", label: this.$i18n.t('table.header.reward_period'), thClass: 'thead-themed align-middle', tdClass: 'text-center align-middle', sortable: true},
                {key: "tukangPost", label: this.$i18n.t('subMenu.my_salon_tukang'), thClass: 'thead-themed align-middle', tdClass: 'text-center align-middle'},
                {key: "action", label: "", thClass: 'thead-themed align-middle', tdClass: 'text-center align-middle'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.caption')).toUpperCase()] = "caption"
            ret[(this.$i18n.t('table.header.like')).toUpperCase()] = "like"
            ret[(this.$i18n.t('table.header.comment')).toUpperCase()] = "comment"
            ret[(this.$i18n.t('table.header.reward_qr')).toUpperCase()] = "rewardQR"
            ret[(this.$i18n.t('salon_report.broadcast.reward_status')).toUpperCase()] = "rewardStatus"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.broadcastExportData)
        }
    },
    methods:{
        isExpired(ts){
            var now = new Date().getTime()
            if(ts*1000 <  now){
                return true
            }else{
                return false
            }
        },
        formatDate(ts, isDT){
            var format = isDT ? this.$msg.CST.DATE_TIME_24 : this.$msg.CST.DATE_FORMAT
            return moment(ts*1000).format(format)
        },
        closeModal(isError){
            if(!isError){
                this.rewardQRToggle = false;
                this.$refs.deleteModal.toggleModal = false
                this.$refs.repostModal.toggleModal = false
                this.filterBroadCastItem()
            }
            this.$parent.isModalShow = false;
        },
        getImage(img){
            return img;
        },
        getOutlet(id){
            return this.outlet.filter(obj => obj.id == id)[0].text
        },
        clearFilter(){
            this.groupFilter = this.searchBroadcast = ""
            this.selectedOutlet = this.outlet[0];
            this.filterBroadCastItem()
        },
        filterSearchBroadcast(){
            this.filterBroadCastItem()
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterBroadCastItem()
        },
        filterByGroup(id){
            this.selectedTab = id;
            this.filterBroadCastItem()
        },
        filterBroadCastItem(){
            this.addToggle = this.editToggle = false
            var searchFilter = this.searchBroadcast == "" ? "" : "&search=" + this.searchBroadcast;
            var outletFilter = this.selectedOutlet.id == 'all' ? '' : '&outletID=' + this.selectedOutlet.id  
            var groupFilter  = this.selectedTab == "all" ? "" : "&broadcast=" + this.selectedTab

            this.setBroadcastItems(searchFilter + outletFilter + groupFilter)
        },
        showRepost(item){
            var title = this.$i18n.t('button_link.repost')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('button_link.repost'), 'item': item.title})
            this.bcastID = item.bcastID
            this.$refs.repostModal.showModal(title, message)
        }, 
        performRepost(){
            let url = this.$api.BROADCAST +  "/" + this.bcastID + this.$api.BROADCAST_REPOST 
            let $vm = this;

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.my_salon_broadcast') +  $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('button_link.repost')})
                    $vm.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        showEdit(item){
            this.sTitle = item.title
            this.$refs.broadcastForm.editForm(item)
            this.editToggle = true
        },
        showBroadcastTarget(bcastID, image){
            this.$refs.broadcastTarget.getBroadcastTarget(bcastID, image)
        },
        showLikeComment(bcastID, action){
            this.$refs.broadcastLikeComment.getBroadcastLikeComment(bcastID, action)
        },
        handleTukangPost(item, action){
            this.$refs.broadcastTukang.setBroadcastTukang(item, action)
        },
        async handleRewardQR(outletID, bcastID, rewardID, rewardTitle, action){
            this.bcastID = bcastID
            this.rewardID = rewardID
            this.rewardTitle = rewardTitle
            this.rewardQRAction = action

            this.rewardQRTitle = action == 'add' ? this.$i18n.t('header.add') + this.$i18n.t('table.header.reward_qr') : this.$i18n.t('header.delete', {'item':  this.$i18n.t('table.header.reward_qr')})
            
            this.rewardQRToggle = true
            await this.getRewardQRItem(outletID)
            this.selectedRewardQR = this.rewardQR[0]
        },
        addRewardQR(){
            const url = this.$api.BROADCAST + "/" + this.bcastID + this.$api.MENU_REWARD_QR

            let $vm = this;
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: {rewardID: this.selectedRewardQR.id}
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = $vm.$i18n.t('table.header.reward_qr') +  $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired($vm.selectedOutlet);   
                }
            })
        },
        deleteRewardQR(){
            const url = this.$api.BROADCAST + "/" + this.bcastID + this.$api.MENU_REWARD_QR + this.$api.DELETE

            let $vm = this;
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: {rewardID: this.rewardID}
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = $vm.$i18n.t('table.header.reward_qr') +  $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired($vm.selectedOutlet);   
                }
            })
        },
        selectRewardQR(item){
            this.selectedRewardQR = item
        },
        deleteBroadcast(item){
            var title = this.$i18n.t('header.delete', {'item': this.$i18n.t(`subMenu.my_salon_broadcast`)})
            var message = this.$i18n.t('message.confirmation.delete_broadcast')
            this.bcastID = item.bcastID
            this.$refs.deleteModal.showModal(title, message)
        },
        performDeleteAction(){
            let $vm = this;
            const url = this.$api.BROADCAST + "/" + this.bcastID + this.$api.DELETE;

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = "Broadcast" + $vm.$msg.DELETE_SUCCESS
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterBroadCastItem()
            }
        },
        setExportData(data){
            this.exportData = []
            let header = this.$msg.REPORT.HEADER  + this.$i18n.t('subMenu.my_salon_broadcast')
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];

            this.exportFileName = header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    date: moment(data[i].postedDate*1000).format(this.$msg.CST.DATE_TIME_24),
                    outlet: data[i].outletID == 0 ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : this.getOutlet(data[i].outletID),
                    topic: data[i].topic == "" ? "-" : data[i].topic,
                    caption: data[i].caption == "" ? "-" : data[i].caption,
                    like: data[i].totalLikes,
                    comment: data[i].totalComments,
                    rewardQR: data[i].rewardTitle == "" ? "-" : data[i].rewardTitle,
                    rewardPeriod: data[i].rewardStartDate == 0 && data[i].rewardEndDate == 0 ? "-" : moment(data[i].rewardStartDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(data[i].rewardEndDate).format(this.$msg.CST.DATE_FORMAT),
                    rewardStatus: data[i].rewardStartDate == 0 && data[i].rewardEndDate == 0 ? "-" : (this.isExpired(data[i].rewardEndDate) ? this.$i18n.t('salon_report.broadcast.expired') : this.$i18n.t('salon_report.broadcast.ongoing')),
                })
            }
        },
        async setBroadcastItems(strFilter){
            this.isSpinnerShow = true
            var result = await this.getBroadcastItems('?page=' + this.page + strFilter)

            var retData = setReturnData(result.result, result.count, this.page)
            this.broadcastItems = retData.result;
            this.totalEntries = result.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            var expResult = await this.getBroadcastItems('?' + strFilter)
            this.broadcastExportData = expResult.result
            this.setExportData(this.broadcastExportData)

        },
        async getBroadcastItems(strFilter){
            // const url = this.$api.OUTLET +"/" + this.selectedOutlet.id + this.$api.BROADCAST + "?page=" + this.page + strFilter;
            const url = this.$api.BROADCAST + strFilter;

            let $vm = this;
            var result = {}

            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                result = response.data
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getRewardQRItem(outletID){
            this.rewardQR = []
            let $vm = this;
            const url = this.$api.OUTLET +"/" + outletID + this.$api.MENU_REWARD_QR ;
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            for(var i=0; i<result.length; i++){
                if(result[i].isEnable == 1){
                    this.rewardQR.push({
                        id: result[i].rewardID,
                        text: result[i].title
                    })
                }
            }
        },
        async getTukangPost(){
            let $vm = this;
            const url = this.$api.TUKANG_ALL_POST
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            result.forEach(obj=>{
                var image = []
                for(var j=1; j<=6; j++){
                    var key = "TkPostImage" + j
                    if(obj[key] != ""){
                        image.push({
                            id: key,
                            src: obj[key],
                            thumbnail: obj[key],
                        })
                    }
                }
                obj.TkPostImage = image
            })
            $vm.tukangPostItems = result
        },
    },
    async mounted(){
        let $vm = this;
        var outlet = JSON.parse($vm.$store.state.outlets)
        $vm.outlet = [{id: 'all', text: $vm.$i18n.t('label.all', {'item': $vm.$i18n.t('label.outlet')})}];
        $vm.outlet.push(...outlet)
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.setBroadcastItems("")
        await $vm.getTukangPost()
    }
}
</script>
<style scoped>
.show{
    display: block;
}
.broadcast-image{
    width: 9em;
    height: 9em;
    border: 2px solid #f3f3f3;
    border-radius: 12px;
}
.nav-link, .link{
    cursor: pointer;
}
.search:hover{
    background: #d6d6d6;
    border: 1px solid #d6d6d6;
}
.broadcast-container{
    justify-content: flex-end;
    align-items: flex-end;
    display: flex;
}
.btn-outline-primary:hover, a.btn-outline-primary:active,
.btn-outline-primary:not(:disabled):not(.disabled):active{
    cursor: default;
    background: transparent;
    color: #886ab5
}
.width-6{
    width: 6%;
}

@media only screen and (max-width: 1412px) {
    .broadcast-container{
        justify-content: none;
        align-items: none;
        display: inline;  
    }
}
</style>